import BaseMapWrapper from "../utils/BaseMapWrapper";
import MapService from "./map";
export default class AMap2Wrapper extends BaseMapWrapper {
  getServiceConstructor() {
    return MapService;
  }
}